import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SearchResultComponent } from '@dinein-lib/shared';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSearchResultComponent extends SearchResultComponent implements OnInit {}
